import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, NavbarBrand } from 'reactstrap';
import ca_insight_logo from './assets/ca_insight_logo.png';


class Header extends React.Component {
    renderSchoolName(){
        return this.props.user.hasOwnProperty('associationName')
            ? (
                <NavbarBrand className="school-name">
                    <span>|</span> { this.props.user.associationName }
                </NavbarBrand>
            )
            : (
                <NavbarBrand>
                    <div className="school-name-placeholder"></div>
                </NavbarBrand>
            );
    }

    render(){
        return (
            <header className="main-header">
                <Link to="/">
                    <img src={ca_insight_logo} alt="Common App Insights" className="ca_insight_logo float-left ml-2" />
                </Link>
                <Navbar color="faded" light toggleable className="py-0">
                    { this.renderSchoolName() }
                </Navbar>
            </header>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/partials/Header.jsx